import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import { languages } from "../constants/languages";
import Button from "@material-ui/core/Button";

export default class ResetMatchesConfirmDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        aria-labelledby="form-dialog-title"
        onClose={this.props.handleClose}
      >
        <DialogTitle id="form-dialog-title">
          {languages.schedule.removeMatchesFromSchedule}
        </DialogTitle>
        <DialogContent style={{ width: 350, maxWidth: "97%" }}>
          <DialogContentText>
            {languages.schedule.removeMatchesFromScheduleConfirm}
          </DialogContentText>
          {this.props.resetMatchesConfirm2 && (
            <DialogContentText style={{ color: "red" }}>
              {languages.schedule.removeMatchesFromScheduleConfirm2}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleClose} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={
              this.props.dayOptions.length > 2
                ? !this.props.resetMatchesConfirm2
                  ? this.props.setResetMatchesConfirm2
                  : this.props.resetMatches
                : this.props.resetMatches
            }
            variant="contained"
            color="primary"
          >
            {languages.general.continue}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
